import { ROLES } from "../../auth/constants";

const config = {
  SITE: 'quality',
  LABEL: 'Quality',
  SITE_ID: 'groups.coca-cola.com,18f2d0a2-e373-4c4a-b16f-64378e8812b8,8b771ee4-a7d7-460c-9a24-7ffcf9e10b58',
  PAGES_LIST_ID: 'e3ebc7ac-0798-4ca1-82fc-1fe77b512766',
  DOCUMENTS_LIST_ID: '2fbcea89-6532-4b67-a3b1-5dd153c92ed0',
  SITE_ASSETS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1isZ3NJnA66Rp6xgI_efN2-',
  DOCUMENTS_DRIVE_ID: 'b!otDyGHPjSkyxb2Q3jogSuOQed4vXpwxGmiR__PnhC1iJ6rwvMmVnS6OxXdFTyS7Q',
  NEWS_TEMPLATE_ID: 'b66907ef-e433-452e-95a4-bebec8f02563',
  SETTINGS_FILE_PATH: 'Settings/HubSettings.json',
  MANAGER_ROLES: [ROLES.QSE_MGR],
  VIVA_COMMUNITY_ID: undefined
}

export default config